import reducer from "./reducers";
export { default as wciActions } from "./actions";

export default reducer;